
import { Component, Renderer2 } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { ApidataService } from '../apidata.service';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Meta, Title } from '@angular/platform-browser';
import { MetaTagService } from '../meta-tag.service';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [HeaderComponent,FooterComponent,CommonModule,HttpClientModule,RouterModule, IconsFreeToolsComponent],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.css',
  providers : [ApidataService]
})
export class PricingComponent {

  default_monthly : boolean = true;
  yearplan : boolean = false;
  profile_id;
  price_id;
  Quarterplan : boolean = false;
  isUserLoggedin : boolean = false;
  private user_id: number;
  premium_user_done;
  selectedplan = '';
  selectedplanaoumt = '';
  constructor(private apidata: ApidataService,  private router: Router, private metaTagService: MetaTagService){
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  ngOnInit(): void {
    this.metaTagService.updateTags("Pricing Plans | Grammarin.com", "Explore our transparent and competitive pricing plans tailored to meet your needs. Find the perfect solution here!", "https://www.grammarin.com/pricing");
    this.activeTab = 'q5';
    this.profile_id = localStorage.getItem("profile_id");
  
    if(this.profile_id ==='1' || this.profile_id == null || this.profile_id == undefined){
      this.profile_id = '1';
      this.isUserLoggedin = false;
    
    }
    else{
      this.isUserLoggedin = true;
      this.profile_id = this.profile_id;
  
    }

    const storedStatus = JSON.parse(localStorage.getItem('premium_user_done') );  
this.premium_user_done = storedStatus;

    if (this.premium_user_done) {
      this.router.navigate(['/openfile'], { queryParams: { ref: 'pricing' } });
    }

 this.removeBackdrop()
  }
  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }

  public customplans(){
    this.router.navigate(['/contact-us'])
  }
  public paymentapiforbasicplan(){
    this.price_id = 'price_1PyABECGbZSVDA9YBZv7fT5b'

     }

  checkUserIdAndRoute(planname, amount, price_id) {
    this.selectedplan = planname;
    this.selectedplanaoumt = amount
    localStorage.setItem('plan', this.selectedplan);
    localStorage.setItem('amount', this.selectedplanaoumt)
    localStorage.setItem('price_id', price_id)

      this.router.navigate(['plans']);

  }

  checkUserIdAndRouteaccounts() {
    this.router.navigate(['/accountsettings']); 
}
checkUserIdAndRoutesignup() {
  this.router.navigate(['/signup']); 
}
checkUserIdAndRouteplans() {
  this.router.navigate(['/plans']); 
}
  activeTab: string = '';

  toggleTab(tabId: string): void {
 
    if (this.activeTab === tabId) {
      this.activeTab = ''; 
    } else {
      this.activeTab = tabId; 
    }
  }









  selectedValue: any =  '1';
  selectedButton1: any =  true;
  selectedButton2: any =  false;
  selectedButton3: any =  false;

  showImageWriteWithoutMistakes: boolean = false;
  showImageSeeYourWritingTone: boolean = true;
  showImageAdjustYourWritingTone: boolean = true;
  showImageRewriteFullSentences: boolean = false;

  showImageWriteFluentlyInEnglish : boolean = false;
  showImageUseInclusiveLanguage : boolean = true;
  showImageCatchAccidentalPlagiarism : boolean = true;
  showImageGenerateTextWithAIPrompts : boolean = true;
  showImageKeepYourCitationsConsistent : boolean = false;

  GenerateTextWithAIPrompts : any = "100 prompts / month"
  GenerateTextWithAIPrompts1 : any = "100 prompts / month"

  selectParagraphMobile(event: any): void {
    this.selectedValue = event.target.value;

    if (this.selectedValue === '1') {
      this.showImageWriteWithoutMistakes = false;
      this.showImageSeeYourWritingTone = true;
      this.showImageAdjustYourWritingTone = true;
      this.showImageRewriteFullSentences = false;
      this.showImageWriteFluentlyInEnglish = false;
      this.showImageUseInclusiveLanguage  = true;
      this.showImageKeepYourCitationsConsistent = false;
      this.showImageCatchAccidentalPlagiarism = true;
      this.showImageGenerateTextWithAIPrompts = true;

      this.GenerateTextWithAIPrompts = "100 prompts / month"
      this.GenerateTextWithAIPrompts1  = "Limited app actions"

      this.selectedButton1 =  true;
      this.selectedButton2 =  false;
      this.selectedButton3 =  false;
    } else if (this.selectedValue === '2') {
      this.showImageWriteWithoutMistakes = false;
      this.showImageSeeYourWritingTone = true;
      this.showImageAdjustYourWritingTone = true;
      this.showImageRewriteFullSentences = true;
      this.showImageWriteFluentlyInEnglish = true;
      this.showImageUseInclusiveLanguage  = true;
      this.showImageKeepYourCitationsConsistent = true;
      this.showImageCatchAccidentalPlagiarism = true;
      this.showImageGenerateTextWithAIPrompts = true;

      this.GenerateTextWithAIPrompts = "100 prompts / month"
      this.GenerateTextWithAIPrompts1  = "All app actions"
      this.selectedButton1 =  false;
      this.selectedButton2 =  true;
      this.selectedButton3 =  false;
    }else if (this.selectedValue === '3') {
      this.showImageWriteWithoutMistakes = false;
      this.showImageSeeYourWritingTone = true;
      this.showImageAdjustYourWritingTone = true;
      this.showImageRewriteFullSentences = true;
      this.showImageWriteFluentlyInEnglish = true;
      this.showImageUseInclusiveLanguage  = true;
      this.showImageKeepYourCitationsConsistent = true;
      this.showImageCatchAccidentalPlagiarism = true;
      this.showImageGenerateTextWithAIPrompts = true;
      this.GenerateTextWithAIPrompts = "2,000 prompts"
      this.GenerateTextWithAIPrompts1  = "All app actions"
      this.selectedButton1 =  false;
      this.selectedButton2 =  false;
      this.selectedButton3 =  true;
    }
  }
  selectedPlan: any = 'Quarterly'; 
  hoveredPlan: string | null = null; 

  
  onHover(plan: string): void {
    this.selectedPlan = plan;
  }


  onLeave(): void {
    this.selectedPlan = 'Quarterly';
  }


  onSelect(plan: string): void {
    this.selectedPlan = plan;
  }


  pricingFeatures = [
    "Write error-free content",
    "Write with fluency",
    "Analyze your writing tone",
    "Free Access to Plagiarism Detection",
    "Free Access to Text Summarizer",
    "Free Access to Paraphrasing",
    "Free Access to AI Assistant and Tools"
  ];
  premiumFeatures = [
    "Everything included in Free Account",
    "Improve your writing tone",
    "Rewrite full sentences for Clarity",
    "Extensive Sentiment Analysis",
    "Refine your writing style and syntax",
    "Unlimited Plagiarism Check",
    "Unlimited Text Summarizer"
  ];
  advancedFeatures = [
    "Unlimited Paraphrasing",
    "Insightful Reports",
    "Centralized billing & Dedicated Support",
    "2,000 AI prompts/month for AI Assistant and AI Tools"
  ];
}
